import React from 'react';
import PropTypes from 'prop-types';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import Divider from "@material-ui/core/Divider";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import AssignmentIcon from '@material-ui/icons/Assignment';
import IconButton from '@material-ui/core/IconButton';
import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import InputAdornment from '@material-ui/core/InputAdornment';
import TextField from "@material-ui/core/TextField";
import Tooltip from '@material-ui/core/Tooltip';
import { withStyles } from '@material-ui/core/styles';
import MapWrapper from "../Map";


const style = () => ({
    formField: {
        marginBottom: 12,
    },
});

const createAddressUrl = (sketchOrder) => {
    let addressUrl = 'https://www.google.com/maps/place/'
    const streetAddress = sketchOrder.address ? sketchOrder.address.replace(' ', '+') : ''
    const locationParams = `${streetAddress}+${sketchOrder.city || ''}+${sketchOrder.region || ''}+${sketchOrder.postCode || ''}`
    return <a href={`${addressUrl}${locationParams}`} rel="noopener noreferrer" target="_blank">{sketchOrder.address} {sketchOrder.city} {sketchOrder.region} {sketchOrder.postCode}</a>;
}

const mapFromPointsToMarkers = (sketchOrder) => {
    if (!sketchOrder.sketchOrderGroup || !sketchOrder.sketchOrderGroup.mapMarkerPoints) {
        return [{
            ordinal: 0,
            latitude: sketchOrder.location.coordinates[1],
            longitude: sketchOrder.location.coordinates[0],
            isCurrentProject: false // don't show the asterisk when there is only 1 marker
        }];
    }

    const markers = sketchOrder.sketchOrderGroup.mapMarkerPoints.map((marker) => {
        const isCurrentProject = marker.point.coordinates[0] === sketchOrder.location.coordinates[0]
            && marker.point.coordinates[1] === sketchOrder.location.coordinates[1];
        return {
            ordinal: marker.ordinal,
            latitude: marker.point.coordinates[1],
            longitude: marker.point.coordinates[0],
            isCurrentProject
        }
    });
    return markers;
};

const SketchOrderCardLocation = props => {
    return (
        <div>
            <Divider />
            <CardContent>
                <Typography variant="h6" gutterBottom>
                    Location
                </Typography>
                {createAddressUrl(props.sketchOrder)}
                <TextField
                    label="Address"
                    name="address"
                    value={props.sketchOrder.address || ''}
                    fullWidth
                    className={props.classes.formField}
                    onChange={props.onSketchOrderChange}
                    inputProps={{
                        readOnly: !props.canEditAddress
                    }}
                />

                <TextField
                    label="City"
                    name="city"
                    value={props.sketchOrder.city || ''}
                    fullWidth
                    className={props.classes.formField}
                    onChange={props.onSketchOrderChange}
                    inputProps={{
                        readOnly: !props.canEditAddress
                    }}
                />

                <TextField
                    label="Region"
                    name="region"
                    value={props.sketchOrder.region || ''}
                    fullWidth
                    className={props.classes.formField}
                    onChange={props.onSketchOrderChange}
                    inputProps={{
                        readOnly: !props.canEditAddress
                    }}
                />

                <TextField
                    label="Postcode"
                    name="postCode"
                    value={props.sketchOrder.postCode || ''}
                    fullWidth
                    className={props.classes.formField}
                    onChange={props.onSketchOrderChange}
                    inputProps={{
                        readOnly: !props.canEditAddress
                    }}
                />

                <TextField
                    label="Country"
                    name="country"
                    value={props.sketchOrder.country || ''}
                    fullWidth
                    className={props.classes.formField}
                    onChange={props.onSketchOrderChange}
                    inputProps={{
                        readOnly: !props.canEditAddress
                    }}
                />

                {
                    props.sketchOrder.location &&
                    <div>
                        <FormControl
                            style={{ marginBottom: 20 }}
                            fullWidth
                        >
                            <InputLabel htmlFor="coordinates">Coordinates</InputLabel>
                            <Input
                                id="coordinates"
                                type="text"
                                value={`${props.sketchOrder.location.coordinates[1]},${props.sketchOrder.location.coordinates[0]}`}
                                endAdornment={
                                    <InputAdornment position="end">
                                        <Tooltip title="Copy to clipboard" placement="top">
                                            <CopyToClipboard text={`${props.sketchOrder.location.coordinates[1]},${props.sketchOrder.location.coordinates[0]}`}>
                                                <IconButton aria-label="Copy coordinates to clipboard">
                                                    <AssignmentIcon />
                                                </IconButton>
                                            </CopyToClipboard>
                                        </Tooltip>
                                    </InputAdornment>
                                }
                            />
                        </FormControl>
                        <MapWrapper
                            draggable={props.canEditLocation}
                            onMarkerChange={props.onLocationChange}
                            markers={mapFromPointsToMarkers(props.sketchOrder)}
                        />
                    </div>
                }
            </CardContent>
        </div>
    );
};

SketchOrderCardLocation.propTypes = {
    sketchOrder: PropTypes.shape({
        address: PropTypes.string,
        city: PropTypes.string,
        region: PropTypes.string,
        postCode: PropTypes.string,
        country: PropTypes.string,
        location: PropTypes.shape(),
        sketchOrderGroup: PropTypes.shape({
            mapMarkerPoints: PropTypes.arrayOf(PropTypes.shape({
                ordinal: PropTypes.number,
                point: PropTypes.shape({
                    coordinates: PropTypes.arrayOf(PropTypes.number),
                }),
            })),
        }),
    }).isRequired,
    onSketchOrderChange: PropTypes.func.isRequired,
    canEditAddress: PropTypes.bool,
    canEditLocation: PropTypes.bool,
    onLocationChange: PropTypes.func.isRequired,
};

SketchOrderCardLocation.defaultProps = {
    canEditAddress: false,
    canEditLocation: false,
};

export default withStyles(style)(SketchOrderCardLocation);
